(function () {
  // ---- 表示済み管理 (sessionStorage / localStorage) ----
  function storageKey(popupId) {
    return 'ap_shown_' + popupId;
  }

  function isAlreadyShown(popupId, suppressDays) {
    if (suppressDays === 0) {
      return sessionStorage.getItem(storageKey(popupId)) === '1';
    }
    var stored = localStorage.getItem(storageKey(popupId));
    if (!stored) return false;
    var elapsed = Date.now() - parseInt(stored, 10);
    return elapsed < suppressDays * 86400000;
  }

  function markShown(popupId, suppressDays) {
    if (suppressDays === 0) {
      sessionStorage.setItem(storageKey(popupId), '1');
    } else {
      localStorage.setItem(storageKey(popupId), Date.now().toString());
    }
  }

  // ---- ポップアップ開閉 ----
  function openPopup(popup) {
    popup.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var focusable = popup.querySelector(
      'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusable) focusable.focus();
  }

  function closePopup(popup) {
    popup.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ---- クリックトリガーの初期化 ----
  function initPopups() {
    document.querySelectorAll('.announcement-popup-trigger').forEach(function (trigger) {
      if (trigger.dataset.popupInitialized) return;
      trigger.dataset.popupInitialized = 'true';
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var popup = document.getElementById(trigger.dataset.popupId);
        if (popup) openPopup(popup);
      });
    });

    document.querySelectorAll('.announcement-popup__overlay, .announcement-popup__close').forEach(function (el) {
      if (el.dataset.popupInitialized) return;
      el.dataset.popupInitialized = 'true';
      el.addEventListener('click', function () {
        var popup = el.closest('.announcement-popup');
        if (popup) closePopup(popup);
      });
    });
  }

  // ---- ページ読み込み時の自動表示 ----
  // ページタイプの判定は Liquid 側（request.page_type）で行い、
  // data-auto-display="true" の属性として渡されているため JS 側では判定不要
  function autoDisplayPopup() {
    var popups = document.querySelectorAll('.announcement-popup[data-auto-display="true"]');

    for (var i = 0; i < popups.length; i++) {
      var popup = popups[i];
      var suppressDays = parseInt(popup.dataset.suppressDays || '0', 10);

      if (!isAlreadyShown(popup.id, suppressDays)) {
        markShown(popup.id, suppressDays);
        (function (p) {
          setTimeout(function () { openPopup(p); }, 800);
        }(popup));
        break; // 複数あっても最初の1件だけ表示
      }
    }
  }

  // ---- ESC キーで閉じる ----
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.announcement-popup[aria-hidden="false"]').forEach(function (popup) {
        closePopup(popup);
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initPopups();
    autoDisplayPopup();
  });

  // テーマエディターでセクション再読み込みされたときも再初期化
  document.addEventListener('shopify:section:load', initPopups);
})();
